/* eslint-disable react/no-unescaped-entities */
const { Component, render } = wp.element;

/* global wp */

import Drawer from "@mui/material/Drawer";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import { Dialog } from "@mui/material";

class Rgpd extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "all"
		};
	}

	_setCookie(name, value, time, interval) {
		var d = new Date;
		if (interval == "day") d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * time);

		if (interval == "hour") d.setTime(d.getTime() + 24 * 60 * 60 * 35 * time);

		document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		location.reload();
	}

	_setCookieValue(bool) {
		this.setState({
			value: !bool ? "mini" : "all"
		});
	}

	_genButton() {
		return (
			<>
				<Button onClick={() => this._setCookie("rgpd", this.state.value, 365, "day")} variant='contained'>J'accepte les cookies</Button>
				<Button onClick={() => this._setCookie("rgpd", "false", 1, "hour")}>Je refuse les cookies</Button>
			</>
		);
	}

	_genContent() {
		return (
			<div id='dialog-content'>
				<h1 className="title-cookie">Cookies</h1>
				<img id="image-cookie" src="https://wikannabis.com/wp-content/uploads/2021/11/cookie.png"></img>
				<span className="desc-cookie">Wikannabis utilise des cookies ou technologies similaires visant à améliorer votre navigation sur le site. Pour en apprendre plus, nous vous invitons à consulter notre <a style={{color:"var(--main-color)"}} href="https://wikannabis.com/politique-de-confidentialite/" target="_blank">Politique de confidentialité</a></span>
				<div className="button-cookie">
					{this._genButton()}
				</div>
			</div>
		);
	}

	render() {
		const isMobile = window.innerWidth < 959;
		if (!isMobile) {
			return (
				<Dialog
					open={true}
					className="dialog-cookie"
				>
					{this._genContent()}
				</Dialog>
			);
		}
		else {
			return (
				<Drawer
					anchor={"bottom"}
					open={true}
					className="drawer-cookie"
				>
					{this._genContent()}
				</Drawer>
			);
		}
	}
}

export default Rgpd;

// Render the app inside our shortcode's #app div
render(
	<Rgpd />,
	document.getElementById("rgpdApp")
);